import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface FieldProps {
  label: string;
  required?: boolean;
  children: ReactNode;
  helperText?: string;
  width?: number | string;
}

const controlStyle: React.CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  height: 40,
  padding: '8px 12px',
  fontSize: 14,
  lineHeight: '20px',
  borderRadius: 8,
  border: '1px solid #d0d5dd',
  backgroundColor: '#fff',
  color: '#101828',
  outline: 'none',
  fontFamily: 'inherit',
};

export const fieldControlStyle = controlStyle;

export default function Field({
  label,
  required,
  children,
  helperText,
  width,
}: FieldProps) {
  return (
    <Box sx={{ width: width ?? '100%' }}>
      <Typography
        component="label"
        variant="body2"
        sx={{
          display: 'block',
          mb: 0.75,
          fontWeight: 500,
          color: '#344054',
        }}
      >
        {label}
        {required && <span style={{ color: '#d92d20', marginLeft: 2 }}>*</span>}
      </Typography>
      {children}
      {helperText && (
        <Typography
          variant="caption"
          sx={{ mt: 0.5, display: 'block', color: '#667085' }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
}
